import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { RootState } from "../../../redux/store";
import { fetchClients, saveClientNum } from "../slices/listClientSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { CustomClient } from "../components";
import { SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";

const ListClient: React.FC = () => {
  const dispatch = useAppDispatch();
  const clients = useAppSelector(
    (state: RootState) => state.listClientSlice.clients
  );
  
  const { t } = useTranslation();
  const {direction} = useAppSelector((state) => state.languageSlice);
  const status = useAppSelector(
    (state: RootState) => state.listClientSlice.status
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");  

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchClients());
    }
  }, [dispatch, status]);

  const getCardColor = (etat: string) => {
    switch (etat) {
      case "Controlé":
      case "Contrôle":
        return "#2B9A28";
      case "Bloqué":
        return "#E73939";
      case "OK":
        return "green";
      default:
        return "gray";
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    setStatusFilter(event.target.value as string);
  };

  const handleClientClick = (NumeroClient: string) => {
    dispatch(saveClientNum(NumeroClient));
    // dispatch(fetchClientDataRepresentant({
    //   NumeroClient: NumeroClient,
    // }));
  };
  

  const filteredClients = (clients ?? []).filter((client) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const matchesSearchTerm =
      client.NumeroClient.toLowerCase().includes(lowerCaseSearchTerm) ||
      client.RaisonSociale.toLowerCase().includes(lowerCaseSearchTerm) ||
      client.Adresse.toLowerCase().includes(lowerCaseSearchTerm) ||
      client.Tel.toLowerCase().includes(lowerCaseSearchTerm);
    const matchesStatus = statusFilter === "" || client.etat === statusFilter;
    return matchesSearchTerm && matchesStatus;
  });

  if (status === "loading") {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (status === "failed") {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography variant="h6" color="error">
          Erreur lors de la récupération des clients
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Typography variant="h5" mb={3} sx={{direction: direction == "ltr" ? "ltr":"rtl"}}>
      {t("listClients.title")}
      </Typography>
      <Grid container columnGap={2} rowGap={2} mb={2}>
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            label={t("listClients.textFilter")}
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={12} md>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="status-filter-label">{t("listClients.statut")}</InputLabel>
            <Select
              labelId="status-filter-label"
              value={statusFilter}
              onChange={handleStatusChange}
              label="Statut"
            >
              <MenuItem value="">Tous</MenuItem>
              <MenuItem value="Controlé">Controlé</MenuItem>
              <MenuItem value="Bloqué">Bloqué</MenuItem>
              <MenuItem value="Libre">Libre</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Box>
        {filteredClients.length > 0 ? (
          filteredClients.map((client , index) => (
            <CustomClient
              key={index}
              nameClient={client.RaisonSociale}
              code={client.NumeroClient}
              tel={client.Tel}
              status={client.etat}
              bg={getCardColor(client.etat)}
              onClickNum={() => handleClientClick(client.NumeroClient)}
            />
          ))
        ) : (
          <Typography variant="body1">Aucun client trouvé</Typography>
        )}
      </Box>
    </>
  );
};

export default ListClient;
